<template>
	<div :class="classes" class="bg-color-content-primary marketing-section text-align-center pl-100-smo pr-100-smo">
		<div class="container">
			<div class="col-8-md col-offset-2-md col-6-lg col-offset-3-lg">
				<slot name="icon"></slot>
				<slot name="heading">
					<h2 class="heading-1 mb-200 text-color-white" v-html="heading"></h2>
				</slot>
				<slot name="summary">
					<p v-if="summary" class="delta text-color-white mb-200" v-html="summary"></p>
				</slot>
				<slot name="link">
					<BaseLink :link="link" :classes="'button button-primary'" />
				</slot>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { CallToAction, Link } from 'types/layout';
import { computed } from 'vue';

interface Props {
	cta?: CallToAction;
	classes?: string;
}

const props = defineProps<Props>();

const heading = computed((): string => {
	return props?.cta?.heading ?? 'Join the future of real estate investing.';
});

const summary = computed((): string => {
	return props?.cta?.summary ?? '';
});

const link = computed((): Link => {
	return (
		props?.cta?.link ?? {
			text: 'Get started',
			router: 'get-started'
		}
	);
});
</script>
